import { isEqual } from "lodash";

import type { IRangeValues } from "pro-features/components/filtersPanel/src/RangeFilter";
import type { RTRawParams } from "app/pages/digital-marketing/keywords-campaigns/reports/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const buildParsedFilterValueFromAPI = (rangeFilter: string, apiParam: string): IRangeValues => {
    const parsedRange = rangeFilter
        .split("|")
        ?.filter((range) => range.includes(apiParam))?.[0]
        .split(",");
    const fromValue = parsedRange.length === 3 ? parsedRange?.[1] : "";
    const toValue = parsedRange.length === 3 ? parsedRange?.[2] : "";
    return {
        fromValue,
        toValue,
    };
};

export const buildDefaultValuesFilterFromUrl = (rangeFilter: string, apiParam: string): IRangeValues => {
    const isFilterDefined = rangeFilter?.includes(apiParam);
    if (isFilterDefined) {
        const parsedVolumeFromUrl = buildParsedFilterValueFromAPI(rangeFilter, apiParam);
        return {
            fromValue: parsedVolumeFromUrl.fromValue,
            toValue: parsedVolumeFromUrl.toValue,
        };
    } else {
        return {
            fromValue: "",
            toValue: "",
        };
    }
};

const handleManagedFilter = (
    rangeFilter: string,
    currentParams: string,
    apiParam: string,
    rangeValue: IRangeValues,
) => {
    const updatedVolumeRequest = `${apiParam},${rangeValue.fromValue},${rangeValue.toValue}`;
    let rangeFilterUpdated;
    if (!rangeFilter) {
        rangeFilterUpdated = updatedVolumeRequest;
    } else if (rangeFilter?.includes(apiParam)) {
        const parsedRange: string[] = rangeFilter.split("|");
        const updatedRange = parsedRange.map((rangeItem) => {
            if (rangeItem.includes(apiParam)) {
                return updatedVolumeRequest;
            }
        });
        rangeFilterUpdated = updatedRange.join("|");
    } else {
        rangeFilterUpdated = `${rangeFilter}|${updatedVolumeRequest}`;
    }

    if (!isEqual(rangeFilterUpdated, currentParams)) {
        proNavigator.updateParams<RTRawParams>({
            rangeFilter: rangeFilterUpdated,
        });
    }
};

export const onRangeFilterChange = (
    rangeFilter: string,
    currentParams: string,
    apiParam: string,
    rangeValue: IRangeValues,
) => {
    if (!rangeValue?.fromValue && !rangeValue?.toValue) {
        removeFilter(rangeFilter, currentParams, apiParam);
    } else {
        handleManagedFilter(rangeFilter, currentParams, apiParam, rangeValue);
    }
};

export const removeFilter = (rangeFilter: string, currentParams: string, apiParam: string): void => {
    const filteredRange = rangeFilter
        ?.split("|")
        ?.filter((range) => !range.includes(apiParam))
        .join("|");
    proNavigator.updateParams<RTRawParams>({
        rangeFilter: filteredRange,
    });
};
